import { render } from "./AwardsSection.vue?vue&type=template&id=1c12843f&scoped=true"
const script = {}

import "./AwardsSection.vue?vue&type=style&index=0&id=1c12843f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c12843f"]])

export default __exports__